import React, { useMemo } from "react";
import { useApiData } from "../hooks/useFetch.js";
import { api } from "../api/api.js";
import StateGuard from "./StateGuard.jsx";
import MargeChart from "../charts/MargeChart.jsx";

export default function MargeTab({
  baseParams,
  prixVente,
  fraisCultureHorsIrrigation,
  equipement,
  selectedEquipParams,
  lissage,
  parHa,
  typeMarge,
  prixEauList,
  prixElecList,
  culture,
  libelle,
}) {
  const params = useMemo(
    () => ({
      ...baseParams,
      prix_vente: prixVente,
      frais_culture_hors_irrigation: fraisCultureHorsIrrigation,
      equipement,
      conso: selectedEquipParams?.conso,
      investissement: selectedEquipParams?.investissement,
      duree_vie: selectedEquipParams?.duree_vie,
      entretien: selectedEquipParams?.entretien,
      efficacite: selectedEquipParams?.efficacite,
      main_doeuvre: selectedEquipParams?.main_doeuvre,
      lissage,
      par_ha: parHa,
      prix_eau: prixEauList,
      prix_elec: prixElecList,
    }),
    [baseParams, prixVente, fraisCultureHorsIrrigation, equipement, selectedEquipParams, lissage, parHa, prixEauList, prixElecList]
  );

  const { data: response, loading, error } = useApiData(api.getMarge, params, {
    // gridno a disparu (la localisation est résolue côté API depuis
    // idExploitation) et idProdu s'appelle désormais idProduction : l'ancienne
    // condition était toujours vraie, donc l'appel n'était jamais lancé.
    skip: !baseParams.idExploitation || !baseParams.idProduction,
  });

  const margeData = response?.data ?? [];
  const rmo = response?.rmo;

  return (
    <div className="oad-panel">
      <h3>
        Marge {typeMarge === "cumul" ? "cumulée" : "annuelle"} 
        {parHa ? " par hectare" : ""} selon les politiques d'irrigation
        {rmo ? ` — rendement moyen sec ${Number(rmo).toFixed(1)} t/ha` : ""}
      </h3>
      <StateGuard
        loading={loading}
        error={error}
        empty={!response || margeData.length === 0}
        emptyMessage="Pas de données pour cette région / scénario."
      >
        {margeData.length > 0 && <MargeChart data={margeData} typeMarge={typeMarge} />}
      </StateGuard>
    </div>
  );
}